/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type SubmitContactUsFormPathParams = NonNullable<operations['submitContactUsForm']['parameters']['path']>;

export type SubmitContactUsFormRequestBody = OperationRequestBodyContent<operations['submitContactUsForm']>;

export interface Input extends SubmitContactUsFormPathParams {
  apiVersion?: string;
  body: SubmitContactUsFormRequestBody;
}

export async function submitContactUsForm(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/internal/contact-us/forms/{formId}/submit', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
